const StandByMe = [
	'BEN E. KING - STAND BY ME',
	'',
	'[Verse 1]',
	'When the night has come',
	'And the land is dark',
	"And the moon is the only light we'll see",
	"No, I won't be afraid",
	"No, I won't be afraid",
	'Just as long as you stand, stand by me',
	'',
	'[Chorus]',
	'So, darling, darling, stand by me',
	'Oh, stand by me',
	'Oh, stand, stand by me',
	'',
	'Stand by me',
	'',
	'[Verse 2]',
	'If the sky that we look upon',
	'Should tumble and fall',
	'Or the mountain should crumble to the sea',
	"I won't cry, I won't cry",
	"No, I won't shed a tear",
	'Just as long as you stand, stand by me',
	'',
	'[Chorus]',
	'And darling, darling, stand by me',
	'Oh, stand by me',
	'Oh, stand now, stand by me',
	'',
	'Stand by me',
	'',
	'[Chorus]',
	'So, darling, darling, stand by me',
	'Oh, stand by me',
	'Oh, stand now, stand by me',
	'Stand by me',
	'',
	"Whenever you're in trouble won't you stand by me, oh, stand by me",
	'Oh, stand now, oh, stand, stand by me',
	'',
	'(fade out)',
];

export default StandByMe;
